import axios from "axios";
import { store } from "../store";

const domain = "https://api.pickapp2.falksson.de";
const loginPath = "/api/v1/auth/login";
const statusPath = "/api/v1/auth/info";

export default {
  login(username, password) {
    const url = domain + loginPath;
    const body = JSON.stringify({
      username,
      password
    });
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json"
    };

    return axios
      .post(url, body, {
        headers,
        withCredentials: true
      })
      .then(_response => {
        const response = _response.data;
        store.commit("userChanged", {
          username: response.data.username,
          realname: response.data.realname
        });
        localStorage.setItem("user", JSON.stringify({
          authdata: window.btoa(username + ":" + password)
        }));
      })
      .catch(e => {
        console.error(e);
      });
  },

  status() {
    const storedUser = localStorage.getItem("user");
    const currentUser = storedUser ? JSON.parse(storedUser) : null;
    if (currentUser && currentUser.authdata) {
      const url = domain + statusPath;
      return fetch(url, {
          headers: {
            Authorization: "Basic " + currentUser.authdata,
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          credentials: "include"
        })
        .then(response => {
            if (response.ok) return response.json()
        })
        .then(response => {
            store.commit("userChanged", {
                username: response.data.username,
                realname: response.data.realname
            });
        })
        .catch(e => {
          localStorage.removeItem("user");
          console.error(e);
        });
    }
  },

  logout() {
    const storedUser = localStorage.getItem("user");
    const currentUser = storedUser ? JSON.parse(storedUser) : null;
    if (currentUser && currentUser.authdata) {
      const url = domain + statusPath;
      return fetch(url, {
          headers: {
            Authorization: "Basic " + currentUser.authdata,
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          credentials: "include"
      })
      .then(response => {
        if (response.ok) return response.json()
      })
      .then(response => {
        localStorage.removeItem("user");
      })
      .catch(e => {
        console.log(e);
        localStorage.removeItem("user");
      });
    }
  }
};
